<template>
  <div>
    <div class="mt-5 text-start padding-box">
      <!-- <h5 class="text-bgreen-200 fw-normal">เลือกอาคาร</h5> -->
      <h4 style="color: #265054" class="fw-bold">
        <router-link to="/main">
          <img src="@/assets/mobile/arrow-left.svg" alt=""
        /></router-link>
        สถานที่ตั้ง
      </h4>
      <div v-if="buildings && buildings.length > 0" class="mt-3 row">
        <div
          v-for="(building, index) in buildings"
          :key="index"
          class="col-12"
          @click="navigateToFillInDaily(building)"
        >
          <div class="position-relative">
            <div class="box d-grid px-0 py-1">
              <img
                v-if="building && building.file"
                :src="building.file.file_url"
                class="mx-auto img-fluid my-2"
                style="max-height: 128px; max-width: 256px"
              />
              <img
                v-else
                :src="require(`@/assets/mobile/building/building.png`)"
                class="mx-auto img-fluid my-2"
                style="max-height: 128px; max-width: 256px"
              />
              <!-- <img
                v-else
                :src="require(`@/assets/mobile/building/${imgs[0]}`)"
                class="w-50 mx-auto"
                style="max-width: 100px"
              /> -->
              <div class="px-3 py-2">
                <h4 class="mt-2 text-start text-building-name">
                  {{
                    `${
                      building && building.company
                        ? building.company.name_en
                        : ""
                    } / ${
                      building && building.branch ? building.branch.name : ""
                    } / ${building ? building.name : ""}`
                  }}
                </h4>

                <hr style="margin: 0.5rem 0" />
                <div
                  class="d-flex align-items-center justify-content-center fs-6"
                >
                  <span class="text-update fw-bold"> ข้อมูลล่าสุด </span>
                  <span class="text-building-update-date ms-auto">
                    {{
                      building &&
                      building.measure_list &&
                      building.measure_list.recent_measure_list_history
                        ? `${formatThaiDate(
                            building.measure_list.recent_measure_list_history
                              .date
                          )}`
                        : "-"
                    }}
                    <!-- {{
                      building && building.last_updated_at
                        ? dateTimeTh(building.last_updated_at)
                        : ""
                    }}
                    ({{
                      building && building.last_updated_at
                        ? timeThai(building.last_updated_at)
                        : ""
                    }}) -->
                  </span>
                </div>
              </div>
            </div>
            <div
              class="rounded-pill bg-noti text-white position-absolute text-center"
              style="
                height: 25px;
                width: 25px;
                top: 0px;
                right: 0;
                margin-right: -15px;
                margin-top: -10px;
              "
            >
              {{
                building && building.number_of_notification
                  ? building.number_of_notification
                  : 0
              }}
            </div>
          </div>
        </div>
        <!-- <b-pagination
          v-model="currentPage"
          :total-rows="totalRows"
          :per-page="limits"
          class="w-100"
          @input="getDataBuildings"
        ></b-pagination> -->
      </div>
      <div v-else>
        <div class="box d-grid">
          <LoadingVue v-if="isLoading" class="mx-auto" />
          <div
            v-if="buildings && buildings.length <= 0"
            class="mx-auto fw-bold"
          >
            ไม่พบข้อมูล
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { httpClient } from "@/token/axios.js";
import { apiURL } from "@/configs/serverConfig";
import helper from "@/mixins/helper";
import LoadingVue from "@/components/LoadingMask.vue";
export default {
  mixins: [helper],
  components: {
    LoadingVue,
  },
  data() {
    return {
      buildings: null,
      imgs: ["buildings2.png", "buildings5.png", "buildingsAuto.png"],
      companyId: "",
      isLoading: false,
      currentPage: 1,
      totalRows: 0,
      limits: 1,
    };
  },
  created() {
    // await this.getCompanyId();
    this.getDataBuildings();
  },
  methods: {
    async getDataBuildings() {
      this.isLoading = true;
      // const url = `https://dev-v1.api.carbonwize.io/api/v1/location?company_id=${this.companyId}&user_relation=WORK_IN`;
      // ?page=${this.currentPage}&size=${this.limits}
      const url = `${apiURL}/building?is_assign=true`;

      try {
        const dataBuildings = await httpClient.get(url);
        // console.log("dataBuildings", dataBuildings);
        if (dataBuildings.data && dataBuildings.data.status != 404) {
          this.totalRows =
            dataBuildings.data.page_information.total_number_of_entities;
          this.buildings = dataBuildings.data.entities;
        }
      } catch (err) {
        console.log(err);
      }
      // setTimeout(() => {
      this.isLoading = false;
      // }, 5000);
    },

    navigateToFillInDaily(building) {
      this.$router.push(
        `/fillin-daily/${building.id}?building=${building.name}`
      );
    },

    // async getCompanyId() {
    //   const url = `${apiURL}/company?user_relation=STAY_IN`;

    //   try {
    //     const companyId = await httpClient.get(url);
    //     this.companyId = companyId.data[0].id;
    //     // console.log('companyId',this.companyId);
    //   } catch (err) {
    //     console.log(err);
    //   }
    // },
  },
};
</script>
<style lang="scss" scoped>
.text-header {
  font-size: 3em;
}

.text-building-name {
  color: #68b281;
  // font-family: Roboto;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px;
}

.text-update {
  color: #1d273f;
  text-align: center;
  // font-family: Roboto;
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
  line-height: 16px; /* 133.333% */
}

.text-building-update-date {
  color: #1d273f;
  text-align: center;
  // font-family: Roboto;
  font-size: 10px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px; /* 160% */
}
</style>
